import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { KineticLines } from "../components/Kinetic";
import { BeforeAfterSlider } from "../components/BeforeAfterSlider";
import { Seo } from "../components/Seo";
import { RESULTS } from "../data/site";

export default function BeforeAfter() {
    return (
        <main data-testid="before-after-page" className="pt-16">
            <Seo title="Before & After Results | Lawn Busters Adelaide"
                description="Real before-and-after results from Lawn Busters jobs across Adelaide — lawn cleanups, weed removal, paving and gutter cleaning. See the difference." />
            <section className="mx-auto max-w-6xl px-6 py-16 lg:py-24">
                <p className="eyebrow text-forest-leaf">Before &amp; After</p>
                <h1 className="mt-4 font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl">
                    <KineticLines lines={["See The", "Difference"]} />
                </h1>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-moss">
                    Real before-and-after results from our Adelaide jobs. Drag the slider on each photo to compare —
                    these are actual jobs completed by our team, presented exactly as they happened.
                </p>
            </section>
            <section className="mx-auto max-w-6xl px-6 pb-20 lg:pb-28">
                <div className="grid gap-12 lg:grid-cols-2">
                    {RESULTS.map((r, i) => (
                        <Reveal key={r.id} delay={i * 0.1}>
                            <BeforeAfterSlider before={r.before} after={r.after} title={r.title} blurb={r.blurb} testid={`results-${r.id}-slider`} />
                        </Reveal>
                    ))}
                </div>
            </section>
            <section className="bg-forest py-16 text-center text-bone lg:py-20">
                <Reveal>
                    <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">Want results like these?</h2>
                    <p className="mx-auto mt-3 max-w-xl text-sm text-bone/70">
                        Book one service or combine several — we'll contact you to confirm the details.
                    </p>
                    <Link to="/book-now" data-testid="results-book-button"
                        className="mt-8 inline-block rounded-full bg-ochre px-8 py-3.5 text-sm font-bold text-forest-night transition-colors hover:bg-bone">
                        Book a Service <ArrowRight size={14} className="ml-1 inline" />
                    </Link>
                </Reveal>
            </section>
        </main>
    );
}
